"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var web3_utils_1 = require("web3-utils");

var Pair_1 = __importDefault(require("./Pair"));

var UniswapTokenPurchase_json_1 = __importDefault(require("./abis/UniswapTokenPurchase.json"));

var UniswapFactory_json_1 = __importDefault(require("./abis/UniswapFactory.json"));

var UNISWAP_FACTORY_ADDRESS = '0xc0a47dfe034b400b47bdad5fecda2621de6c4d95';
var UNISWAP_NETWORK = '1';
var DEADLINE = 1742680400;

var Uniswap =
/** @class */
function (_super) {
  __extends(Uniswap, _super);

  function Uniswap(asset) {
    var _this = _super.call(this, {
      assetA: asset,
      assetB: 'eth'
    }) || this;

    _this.contract = null;
    return _this;
  }

  Uniswap.prototype.setExchange = function (exchange) {
    this.exchange = exchange;
    this.web3 = exchange.getWeb3(UNISWAP_NETWORK);
  };

  Uniswap.prototype.getContract = function () {
    return __awaiter(this, void 0, void 0, function () {
      var factoryContract, asset, exchangeAddress;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!!this.contract) return [3
            /*break*/
            , 2];
            factoryContract = new this.web3.eth.Contract(UniswapFactory_json_1.default, UNISWAP_FACTORY_ADDRESS);
            asset = this.exchange.getAsset(this.assetA);
            return [4
            /*yield*/
            , factoryContract.methods.getExchange(asset.address).call()];

          case 1:
            exchangeAddress = _a.sent();

            if (!exchangeAddress) {
              throw new Error("Can not find Uniswap exchange for asset " + this.assetA);
            }

            console.log("Found Uniswap for " + this.assetA + " at " + exchangeAddress);
            this.contract = new this.web3.eth.Contract(UniswapTokenPurchase_json_1.default, exchangeAddress);
            _a.label = 2;

          case 2:
            return [2
            /*return*/
            , this.contract];
        }
      });
    });
  };

  Uniswap.prototype.exchangeAtoB = function (_a) {
    var account = _a.account,
        value = _a.value,
        ether = _a.ether;
    return __awaiter(this, void 0, void 0, function () {
      var _value, asset, contract, uniswapAllowance, allowanceReceipt;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _value = this._getValue({
              value: value,
              ether: ether
            });
            asset = this.exchange.getAsset(this.assetA);
            return [4
            /*yield*/
            , this.getContract()];

          case 1:
            contract = _b.sent();
            return [4
            /*yield*/
            , asset.allowance(account, contract.address)];

          case 2:
            uniswapAllowance = _b.sent();
            if (!web3_utils_1.toBN(uniswapAllowance).lt(web3_utils_1.toBN(_value))) return [3
            /*break*/
            , 4];
            return [4
            /*yield*/
            , asset.approve(account, contract.address, _value)];

          case 3:
            allowanceReceipt = _b.sent();
            console.log(allowanceReceipt);
            _b.label = 4;

          case 4:
            return [4
            /*yield*/
            , contract.methods.tokenToEthSwapInput(_value, 1, DEADLINE).send({
              from: account
            })];

          case 5:
            return [2
            /*return*/
            , _b.sent()];
        }
      });
    });
  };

  Uniswap.prototype.exchangeBtoA = function (_a) {
    var account = _a.account,
        value = _a.value,
        ether = _a.ether;
    return __awaiter(this, void 0, void 0, function () {
      var _value, contract;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _value = this._getValue({
              value: value,
              ether: ether
            });
            return [4
            /*yield*/
            , this.getContract()];

          case 1:
            contract = _b.sent();
            return [2
            /*return*/
            , contract.methods.ethToTokenSwapInput(1, DEADLINE).send({
              from: account,
              value: _value
            })];
        }
      });
    });
  };

  return Uniswap;
}(Pair_1.default);

exports.default = Uniswap;